<!-- filepath: /Users/desarrollo/Documents/Proyectos/friax/src/components/default/Header.vue -->
<template>

  <iframe
    src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d6995.581289890397!2d-106.11475!3d28.755666999999995!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDQ1JzIwLjQiTiAxMDbCsDA2JzUzLjEiVw!5e0!3m2!1ses-419!2sus!4v1740380996278!5m2!1ses-419!2sus"
    style="border:0;" width="100%" height="100%" allowfullscreen="" loading="lazy"
    referrerpolicy="no-referrer-when-downgrade" />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MenBar'
});
</script>